/* GST Invoice cart-attribute form — Jainsons Lights */
(function () {
  'use strict';

  // GSTIN: 2-digit state + 5 letters + 4 digits + 1 letter + 1 alphanum + 'Z' + 1 alphanum
  var GSTIN_RE = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;

  var STATE_BY_CODE = {
    '01': 'Jammu & Kashmir', '02': 'Himachal Pradesh', '03': 'Punjab',
    '04': 'Chandigarh', '05': 'Uttarakhand', '06': 'Haryana', '07': 'Delhi',
    '08': 'Rajasthan', '09': 'Uttar Pradesh', '10': 'Bihar', '11': 'Sikkim',
    '12': 'Arunachal Pradesh', '13': 'Nagaland', '14': 'Manipur', '15': 'Mizoram',
    '16': 'Tripura', '17': 'Meghalaya', '18': 'Assam', '19': 'West Bengal',
    '20': 'Jharkhand', '21': 'Odisha', '22': 'Chhattisgarh', '23': 'Madhya Pradesh',
    '24': 'Gujarat', '25': 'Daman & Diu', '26': 'Dadra & Nagar Haveli',
    '27': 'Maharashtra', '28': 'Andhra Pradesh', '29': 'Karnataka', '30': 'Goa',
    '31': 'Lakshadweep', '32': 'Kerala', '33': 'Tamil Nadu', '34': 'Puducherry',
    '35': 'Andaman & Nicobar', '36': 'Telangana', '37': 'Andhra Pradesh',
    '38': 'Ladakh', '97': 'Other Territory'
  };

  function debounce(fn, wait) {
    var t;
    return function () {
      var ctx = this, args = arguments;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(ctx, args); }, wait);
    };
  }

  function deriveState(gstin) {
    if (!gstin || gstin.length < 2) return null;
    return STATE_BY_CODE[gstin.substring(0, 2)] || null;
  }

  function validateGstin(gstin) {
    if (!gstin) return { ok: false, msg: '' };
    if (gstin.length < 15) return { ok: false, msg: 'GSTIN must be 15 characters.' };
    if (!GSTIN_RE.test(gstin)) return { ok: false, msg: 'Invalid GSTIN format. Please check.' };
    var state = deriveState(gstin);
    if (!state) return { ok: false, msg: 'Unrecognised state code in GSTIN.' };
    return { ok: true, state: state, msg: 'Valid GSTIN — registered in ' + state + '.' };
  }

  class GstInvoice extends HTMLElement {
    constructor() {
      super();
      this.toggle = this.querySelector('[data-gst-toggle]');
      this.fields = this.querySelector('[data-gst-fields]');
      this.gstinInput = this.querySelector('[data-gst-gstin]');
      this.businessInput = this.querySelector('[data-gst-business]');
      this.feedback = this.querySelector('[data-gst-feedback]');
      this.bind();
      // Prefill state-derived feedback if we already have a value
      if (this.gstinInput.value) this.handleGstinInput({ target: this.gstinInput });
    }

    bind() {
      this.toggle.addEventListener('change', this.handleToggle.bind(this));
      this.gstinInput.addEventListener('input', this.handleGstinInput.bind(this));
      this.businessInput.addEventListener('input', this.debouncedSave.bind(this));
      this.gstinInput.addEventListener('blur', this.debouncedSave.bind(this));
      this.businessInput.addEventListener('blur', this.debouncedSave.bind(this));
    }

    handleToggle() {
      var open = this.toggle.checked;
      if (open) {
        this.fields.removeAttribute('hidden');
        // Restore saved GSTIN from customer profile if both fields empty
        if (!this.gstinInput.value && this.dataset.savedGstin) {
          this.gstinInput.value = this.dataset.savedGstin;
          this.businessInput.value = this.dataset.savedBusiness || '';
          this.handleGstinInput({ target: this.gstinInput });
        }
      } else {
        this.fields.setAttribute('hidden', '');
      }
      this.save();
    }

    handleGstinInput(e) {
      // Force uppercase + strip whitespace
      var v = (e.target.value || '').toUpperCase().replace(/\s+/g, '');
      if (e.target.value !== v) e.target.value = v;
      this.renderFeedback(v);
      this.debouncedSave();
    }

    renderFeedback(gstin) {
      if (!gstin) {
        this.feedback.textContent = '';
        this.feedback.className = 'gst-invoice__feedback';
        return;
      }
      var res = validateGstin(gstin);
      if (res.ok) {
        this.feedback.textContent = res.msg;
        this.feedback.className = 'gst-invoice__feedback gst-invoice__feedback--ok';
      } else if (gstin.length > 0) {
        this.feedback.textContent = res.msg;
        this.feedback.className = 'gst-invoice__feedback gst-invoice__feedback--error';
      }
    }

    save() {
      var required = this.toggle.checked;
      var gstin = (this.gstinInput.value || '').toUpperCase().replace(/\s+/g, '');
      var business = (this.businessInput.value || '').trim();
      var state = deriveState(gstin) || '';

      var payload = {
        attributes: {
          'gst_invoice_required': required ? 'true' : '',
          'gstin': required ? gstin : '',
          'gst_business_name': required ? business : '',
          'gst_state': required ? state : ''
        }
      };

      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(payload)
      }).catch(function (err) {
        // Silent fail — fields will retry on next change
        if (window.console && console.warn) console.warn('GST attr save failed:', err);
      });
    }
  }

  GstInvoice.prototype.debouncedSave = debounce(function () { this.save(); }, 500);

  if (!customElements.get('gst-invoice')) {
    customElements.define('gst-invoice', GstInvoice);
  }
})();
